import { render, staticRenderFns } from "./ComplainTypeListTable.vue?vue&type=template&id=435237fa&"
import script from "./ComplainTypeListTable.vue?vue&type=script&lang=js&"
export * from "./ComplainTypeListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports